<template>
  <div class="modal fade lost_code" id="lost_code_popup" tabindex="-1" role="dialog"
       aria-labelledby="" aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                @click="closeModal()">
          <img src="static/img/millen_images/popup-close.svg" alt="">
        </button>
        <div class="modal-header">
          <h5 class="modal-title">Ben je je speelcode kwijt?</h5>
          <h4>
            Geen probleem. Vul hier je mobiele nummer in en we sturen je laatst ontvangen speelcode
            nogmaals.
            Let wel op: elke Prepaid Surprise-speelcode is 14 dagen geldig!
          </h4>
        </div>
        <div class="modal-body">
          <form>
            <div :class="{'form-group': true, 'error': !isValidMsisdn}">
              <input v-model="msisdn" type="tel" class="form-control" id="mobile" name="mobile"
                     placeholder="Mobiele nummer"
                     required/>
              <label v-if="!isValidMsisdn" class="form-control-label" for="mobile">Mobiele nummer</label>
              <div v-if="!isValidMsisdn" class="error_msg">
                Ongeldig mobiele nummer. Je mobiele nummer moet beginnen met 06 en bestaat uit 10
                cijfers.
                Of beginnend met 097 en bestaand uit 12 cijfers.
              </div>
              <div v-if="!hasCodes" class="error_msg">
                Je hebt momenteel geen speelcodes
              </div>
              <div v-if="!codesNotAlreadyRequested" class="error_msg">
                Oeps, je kunt je verloren codes maar één keer per dag opvragen. Probeer het morgen
                opnieuw.
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" @click.prevent="submitLostCode" :disabled="disabled"
                  class="black_btn">Speelcode
            opvragen
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapMutations} from 'vuex';
import gtm_analytics from "../../common/mixin/gtm_analytics";

export default {
  name: 'LostCode',
  mixins:[
    gtm_analytics
  ],
  data() {
    return {
      msisdn: null,
      isValidMsisdn: true,
      hasCodes: true,
      codesNotAlreadyRequested: true,
      disabled: false
    }
  },
  mounted() {
    $('#lost_code_popup').modal('show')
    this.pushPopUp('Popup visit','Lost Code Pop Up')
  },
  methods: {
    ...mapMutations([
      'updateLostCodeModal',
      'updateRedemptionMsisdn',
    ]),
    ...mapActions([
      'getLostCodes'
    ]),
    closeModal() {
      this.updateLostCodeModal(false)
      $('#play_now_popup').modal('hide')
    },
    validateForm() {
      this.isValidMsisdn = this.msisdnValidation()
      return this.isValidMsisdn
    },
    msisdnValidation() {
      return (/^(06[0-9]{8}|097[0-9]{9})$/.test(this.msisdn))
    },
    resetErrorMessages() {
      this.isValidMsisdn = true
      this.hasCodes = true
      this.codesNotAlreadyRequested = true
    },
    submitLostCode() {
      this.resetErrorMessages()
      if (this.disabled) {
        return
      }
      if (this.validateForm()) {
        this.disabled = true
        this.updateRedemptionMsisdn(this.msisdn)
        this.getLostCodes()
          .then((response) => {
            if (response.data !== undefined && response.data === "NO_CODES") {
              this.hasCodes = false
            } else if (response.data !== undefined && response.data === "CONVERSATION_LIMIT") {
              this.codesNotAlreadyRequested = false
            } else if (response.data !== undefined && response.data.failReason !== null) {
              this.isValidMsisdn = false
            } else if (response.data !== undefined && response.data.failReason === null) {
              this.$store.commit('updateLostCodeModal', false)
              $('#lost_code_popup').modal('hide')
            }
            this.disabled = false
          })
          .catch((error) => {
            console.log('an error occurred: ' + error)
            this.disabled = false
            this.isValidMsisdn = false
          })
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modals/LostCode.vue